declare const pdfMake;

/**
 * A service used to generate pdfs
 */
export class PdfGeneratorService {
  /**
   * Requests a table layout PDF preview for a given data structure to be rendered in the browser window
   *
   * @param headerRow An array of values to be used as table headings
   * @param dataRows An array of data rows containing data values (see example code snippet)
   * @param colWidths An array of column widths to be assigned to the table. The number of column width values supplied must match the number of columns to be displayed
   * @param pageHeading Text to be displayed for the page heading
   */
  public exportAsTable(headerRow, dataRows, colWidths: Array<string | number>, pageHeading: string) {
    let docDefinition;
    const docBody = [];
    if (headerRow) {
      docBody.push(headerRow);
    }
    dataRows.forEach((dataRow) => {
      docBody.push(dataRow);
    });

    docDefinition = {
      info: {
        title: pageHeading,
        author: 'Applied Card Technologies Ltd'
      },
      pageSize: 'A4',
      pageOrientation: 'landscape',
      content: [
        {
          table: {
            headerRows: headerRow ? 1 : 0,
            widths: colWidths,
            body: docBody
          },
          layout: 'lightHorizontalLines'
        }
      ],
      header: { text: pageHeading, alignment: 'center' },
      footer: (currentPage, pageCount) => {
        return { text: 'Page ' + currentPage.toString() + ' of ' + pageCount, alignment: 'center' };
      }
    };

    pdfMake.createPdf(docDefinition).download(pageHeading + '.pdf');
  }
}
